import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DownloadFileButton } from '@components/DownloadFileButton/index';
import { Curriculum } from '@components/Curriculum/index';
import { useDownloadDossier } from '@utils/hooks/use-download-dossier/use-download-dossier';

export const CandidateDossier = ({ candidateSummary }) => {
  const { t } = useTranslation(null, {
    keyPrefix: 'candidateDetails.dossier',
  });

  const onDownloadDossierClick = useDownloadDossier();

  return (
    <div className="rev-o-container">
      <div className="rev-o-grid">
        <div className="rev-o-col-12 rev-u-px-16 rev-u-mt-40">
          <div className="rev-o-antipodes rev-u-pt-48 rev-u-pb-24">
            <p className="rev-o-antipodes__item rev-o-typo-heading-5 rev-u-color-primary-100">
              {t('title')}
            </p>

            <DownloadFileButton
              className="rev-o-antipodes__item"
              onClick={onDownloadDossierClick}
              label={t('button')}
            />
          </div>

          <Curriculum summary={candidateSummary} />
        </div>
      </div>
    </div>
  );
};

CandidateDossier.propTypes = {
  candidateSummary: PropTypes.string,
};
